var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17.932,
  height: 21.91,
  viewBox: "0 0 17.932 21.91"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Shield",
  d: "M11.982,22.911a1.985,1.985,0,0,1-.682-.12,14.417,14.417,0,0,1-5.754-3.364A8.943,8.943,0,0,1,3,12.95V5.979A1.994,1.994,0,0,1,4.992,3.988a9.62,9.62,0,0,0,5.559-2.463l.008-.007a2.161,2.161,0,0,1,2.807,0l.009.007a9.468,9.468,0,0,0,5.559,2.463A1.994,1.994,0,0,1,20.926,5.98v6.97a8.953,8.953,0,0,1-2.543,6.477A14.48,14.48,0,0,1,12.629,22.8h-.008a1.988,1.988,0,0,1-.639.111ZM11.855,3.03A11.4,11.4,0,0,1,4.992,5.979V12.95c0,3.79,2.214,6.32,6.967,7.962l.023.008c4.743-1.655,6.952-4.188,6.952-7.97V5.979A11.393,11.393,0,0,1,12.07,3.03a.169.169,0,0,0-.215,0Z",
  transform: "translate(-2.998 -1)",
  fill: "currentColor"
})));
export { SvgShield as ReactComponent };
export default __webpack_public_path__ + "static/media/Shield.44ceeddcf2020c7c2fab01f163c26521.svg";